/** 文档接口。 */
import { http } from '@/utils/request'
import type { DocumentContent, DocumentItem, DocumentUpdate } from '@/types/document'
import type { ApiMessage } from '@/types/common'

export function getDocs(params?: {
  q?: string
  category?: string
  published?: string
}): Promise<DocumentItem[]> {
  return http.get<DocumentItem[]>('/docs', { params })
}

export function getDoc(id: number): Promise<DocumentItem> {
  return http.get<DocumentItem>(`/docs/${id}`)
}

export function getDocContent(id: number): Promise<DocumentContent> {
  return http.get<DocumentContent>(`/docs/${id}/content`)
}

export function updateDocContent(id: number, content: string): Promise<DocumentContent> {
  return http.put<DocumentContent>(`/docs/${id}/content`, { content })
}

export function uploadDoc(file: File, metadata: Record<string, unknown>): Promise<DocumentItem> {
  const formData = new FormData()
  formData.append('file', file)
  Object.entries(metadata).forEach(([key, value]) => {
    formData.append(key, String(value))
  })
  return http.post<DocumentItem>('/docs', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export function updateDoc(id: number, payload: DocumentUpdate): Promise<DocumentItem> {
  return http.put<DocumentItem>(`/docs/${id}`, payload)
}

export function deleteDoc(id: number): Promise<ApiMessage> {
  return http.delete<ApiMessage>(`/docs/${id}`)
}

export function updateDocsOrder(ids: number[]): Promise<ApiMessage> {
  return http.put<ApiMessage>('/docs/sort', { ids })
}

export function getDocCategories(): Promise<string[]> {
  return http.get<string[]>('/docs/categories')
}
